<template>
  <v-layout row justify-center>
    <v-dialog v-model="open" persistent max-width="40vw">
      <v-card>
        <v-card-title class="headline">Relance groupée</v-card-title>
        <v-card-text>Envoyer une relance groupée à tous les étudiants...</v-card-text>
        <v-card-text>
          <v-container fluid>
            <v-flex xs12>
              <v-select :items="types" label="Type de relance" v-model="type" color="teal"></v-select>
            </v-flex>
            <!-- <v-flex xs12>
              <v-select :items="vectors" label="Vecteur" v-model="vector" color="teal"></v-select>
            </v-flex>-->
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="teal darken-1" flat @click="closeModal" :disabled="sending">Annuler</v-btn>
          <v-btn
            color="teal darken-1"
            flat
            @click="sendReminders(type, vector)"
            :disabled="sending || !type"
          >Envoyer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  props: ['open', 'sending', 'closeModal', 'sendReminders'],
  data: () => ({
    types: [
      {
        text: "qui n'ont pas changé leur mot de passe",
        value: 'passwordChanged',
      },
      {
        text: "qui n'ont pas accepté le code de savoir-vivre",
        value: 'codeOfConductAccepted',
      },
      {
        text: "qui n'ont pas complété le formulaire AHES",
        value: 'ahesFormValidated',
      },
    ],
    vectors: [
      {
        text: 'E-mail',
        value: 'email',
      },
      {
        text: 'SMS',
        value: 'sms',
      },
    ],
    type: undefined,
    vector: 'email',
  }),
};
</script>